import * as React from "react";
import { Fade } from "react-bootstrap";

interface OwnProps {
    css?: string;
    cssWrapper?: string;
    message?: string;
    minHeight?: any;
    msgTopPos?: any;
    show?: boolean;
}

export const LoadingSpinner: React.SFC<OwnProps> = (props) => {

    const wrapStyle: React.CSSProperties = {};
    if (props.minHeight !== undefined)
        wrapStyle.minHeight = props.minHeight;

    const msgStyle: React.CSSProperties = {};
    if (props.msgTopPos !== undefined)
        msgStyle.top = props.msgTopPos;

    return (
        <Fade in={!!props.show} unmountOnExit onEntered={() => {}} onExited={() => {}}>
            <div className={(props.cssWrapper || "loading-overlay")} style={wrapStyle}>
                <div className={props.css || "loading"} style={msgStyle}>
                    {props.message || <span><i className="fa fa-spinner fa-spin"></i> Loading&hellip;</span>}
                </div>
            </div>
        </Fade>
    );
};



// WEBPACK FOOTER //
// ./src/components/generic/LoadingSpinner.tsx